module.exports = __webpack_public_path__ + "img/zsdxfsdw.71678aed.png";